import {InertiaLink, usePage} from "@inertiajs/inertia-react";
import {createColumnHelper} from "@tanstack/react-table";
import {IconButton} from "@material-ui/core";
import {Trans} from "../../utils/i18n";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import CreateIcon from "@material-ui/icons/Create";
import React, {useMemo} from "react";
import dayjs from "dayjs";
import {getAppointmentStatusTranslation} from "../../utils/appointmentUtils";

export default function useUnzerTableConfig() {
    const { extendedMode, permissions, requesttypes, active_requesttype, partners, companies, } = usePage().props;
    const url = usePage().url;

    return useMemo(() => {
        const columnHelper = createColumnHelper();

        let array = [];

        if(active_requesttype === 'ta72' || active_requesttype === 'calls' || active_requesttype === 'vvl' || active_requesttype === 'new') {
            array = [
                columnHelper.accessor(row => row.appointments, {
                    id: 'appointments',
                    header: () => <Trans i18nKey="appointment.form.appointments">Appointments</Trans>,
                    enableSorting: false,
                    cell: ({ getValue }) => {
                        return (
                            <div className="px-1">
                                {
                                    getValue()
                                        ?.sort((a, b) => dayjs(a.start_time).unix() - dayjs(b.start_time).unix())
                                        ?.slice(-1)
                                        ?.map(item => <p key={item.id}>{dayjs(item.start_time).format('DD.MM.YYYY HH:mm')}: {getAppointmentStatusTranslation(item)}</p>)
                                }
                            </div>
                        );
                    },
                }),
            ];
        }

        return [
            columnHelper.display({
                id: 'collapse',
                cell: ({ row }) => (
                    <div className="px-1">
                        <IconButton
                            aria-label={<Trans i18nKey="queues.expandRow">expand row</Trans>}
                            size="small"
                            onClick={row.getToggleSelectedHandler()}
                        >
                            {row.getIsSelected() ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </div>
                ),
            }),
            columnHelper.accessor(row => row.number, {
                id: 'number',
                header: () => <Trans i18nKey="queues.jobNumber">Job number</Trans>,
            }),
            columnHelper.accessor(row => row.service, {
                id: 'services.name',
                header: () => <Trans i18nKey="queues.service">Service</Trans>,
            }),
            columnHelper.accessor(row => row.partner?.name, {
                id: 'partners.name',
                header: () => <Trans i18nKey="queues.partner">Partner</Trans>,
            }),
            ...array,
            columnHelper.accessor(row => row.installation_address?.name, {
                id: 'addresses.name',
                header: () => <Trans i18nKey="queues.customer">Customer</Trans>,
            }),
            columnHelper.accessor(row => row.status?.currentStatus?.name, {
                id: 'statuses.name',
                header: () => <Trans i18nKey="queues.status">Status</Trans>,
            }),
            columnHelper.accessor(row => row.status?.currentStatus?.exception, {
                id: 'exception',
                header: () => <Trans i18nKey="queues.exception">Exception</Trans>,
                enableSorting: false,
            }),
            columnHelper.accessor(row => row.created_at, {
                id: 'created_at',
                header: () => <Trans i18nKey="queues.creationDate">Creation date</Trans>,
            }),
            columnHelper.display({
                id: 'action',
                header: () => <Trans i18nKey="queues.action">Action</Trans>,
                cell: ({ row }) => {
                    return <div>
                        <InertiaLink href={route('queue.details', { order: row.original?.order_id, returnUrl: url })}>
                            <CreateIcon color={'primary'}/>
                        </InertiaLink>
                    </div>;
                }
            }),
        ];
    }, [active_requesttype]);
}
